export const ResourceAuthEnum = {
    //采购单（新增）
    P_AD: "scm-z.p.p.ad-2",
    //采购单（新增-补单）
    P_AD_REPL: "scm-z.p.p.ad.repl-2",
    //采购单（新增-保存）
    P_AD_SAVE: "scm-z.p.p.ad.save-2",
    //采购单（编辑）
    P_ED: "scm-z.p.p.ed-2",
    //采购单（编辑-打印）
    P_ED_PRINT: "scm-z.p.p.ed.print-2",
    //采购单（编辑-作废）
    P_ED_CANCEL: "scm-z.p.p.ed.cancel-2",
    //采购单（编辑-保存）
    P_ED_SAVE: "scm-z.p.p.ed.save-2",
    //采购单（编辑-直发确认）
    P_ED_D_CONFIRM: "scm-z.p.p.ed.d-confirm-2",
    //采购单（编辑-库房确认）
    P_ED_CONFIRM: "scm-z.p.p.ed.confirm-2",
    //采购单（编辑-结算）
    P_ED_BILL: "scm-z.p.p.ed.bill-2",
    //采购单（编辑-直发结算）
    P_ED_D_BILL: "scm-z.p.p.ed.d-bill-2",
    //采购单（编辑-转销售单）
    P_ED_TRANS: "scm-z.p.p.ed.trans-2",
    //采购单（编辑-新增商品）
    P_ED_ADD_M: "scm-z.p.p.ed.add-m-2",
    //采购单（编辑-删除商品）
    P_ED_DEL_M: "scm-z.p.p.ed.del-m-2",
    //采购单（编辑-下载模板）
    P_ED_DLOAD: "scm-z.p.p.ed.dload-2",
    //采购单（编辑-导入商品）
    P_ED_IM: "scm-z.p.p.ed.im-2",
    //采购单（导出）
    P_EX: "scm-z.p.p.ex-2",


    //采购退货（新增）
    PR_AD: "scm-z.p.pr.ad-2",
    //采购退货（新增-保存）
    PR_AD_SAVE: "scm-z.p.pr.ad.save-2",
    //采购退货（编辑）
    PR_ED: "scm-z.p.pr.ed-2",
    //采购退货（编辑-打印）
    PR_ED_PRINT: "scm-z.p.pr.ed.print-2",
    //采购退货（编辑-作废）
    PR_ED_CANCEL: "scm-z.p.pr.ed.cancel-2",
    //采购退货（编辑-保存）
    PR_ED_SAVE: "scm-z.p.pr.ed.save-2",
    //采购退货（编辑-库房确认）
    PR_ED_CONFIRM: "scm-z.p.pr.ed.confirm-2",
    //采购退货（编辑-结算）
    PR_ED_BILL: "scm-z.p.pr.ed.bill-2",
    //采购退货（编辑-新增商品）
    PR_ED_ADD_M: "scm-z.p.pr.ed.add-m-2",
    //采购退货（编辑-删除商品）
    PR_ED_DEL_M: "scm-z.p.pr.ed.del-m-2",
    //采购退货（编辑-导入商品）
    PR_ED_IM: "scm-z.p.pr.ed.im-2",
    //采购退货（导出）
    PR_EX: "scm-z.p.pr.ex-2",
    //采购退货-下载模板）
    PR_ED_DLOAD: "scm-z.p.pr.ed.dload-2",

    //销售订单（新增）
    SO_AD: "scm-z.s.so.ad-2",
    //销售订单（新增-保存）
    SO_AD_SAVE: "scm-z.s.so.ad.save-2",
    //销售订单（编辑）
    SO_ED: "scm-z.s.so.ed-2",
    //销售订单（编辑-打印）
    SO_ED_PRINT: "scm-z.s.so.ed.print-2",
    //销售订单（编辑-作废）
    SO_ED_CANCEL: "scm-z.s.so.ed.cancel-2",
    //销售订单（编辑-保存）
    SO_ED_SAVE: "scm-z.s.so.ed.save-2",
    //销售订单（编辑-转销售单）
    SO_ED_TRANS: "scm-z.s.so.ed.trans-2",
    //销售订单（编辑-新增商品）
    SO_ED_ADD_M: "scm-z.s.so.ed.add-m-2",
    //销售订单（编辑-删除商品）
    SO_ED_DEL_M: "scm-z.s.so.ed.del-m-2",
    //销售订单（编辑-下载模板）
    SO_ED_DLOAD: "scm-z.s.so.ed.dload-2",
    //销售订单（编辑-导入商品）
    SO_ED_IM: "scm-z.s.so.ed.im-2",
    //销售订单（导出）
    SO_EXPORT: "scm-z.s.so.ex-2",

    //销售单（新增）
    S_AD: "scm-z.s.s.ad-2",
    //销售单（新增 -补单）
    S_AD_REPL: "scm-z.s.s.ad.repl-2",
    //销售单（新增-保存）
    S_AD_SAVE: "scm-z.s.s.ad.save-2",
    //销售单（编辑）
    S_ED: "scm-z.s.s.ed-2",
    //销售单（编辑-打印）
    S_ED_PRINT: "scm-z.s.s.ed.print-2",
    //销售单（编辑-作废）
    S_ED_CANCEL: "scm-z.s.s.ed.cancel-2",
    //销售单（编辑-保存）
    S_ED_SAVE: "scm-z.s.s.ed.save-2",
    //销售单（编辑-结算）
    S_ED_BILL: "scm-z.s.s.ed.bill-2",
    //销售单（编辑-库房确认）
    S_ED_CONFIRM: "scm-z.s.s.ed.confirm-2",
    //销售单（编辑-新增商品）
    S_ED_ADD_M: "scm-z.s.s.ed.add-m-2",
    //销售单（编辑-删除商品）
    S_ED_DEL_M: "scm-z.s.s.ed.del-m-2",
    //销售单（编辑-下载模板）
    S_ED_DLOAD: "scm-z.s.s.ed.dload-2",
    //销售单（编辑-导入商品）
    S_ED_IM: "scm-z.s.s.ed.im-2",
    //销售单（导出）
    S_EXPORT: "scm-z.s.s.ex-2",


    //销售退货（新增）
    SR_AD: "scm-z.s.sr.ad-2",
    //销售退货（新增-保存）
    SR_AD_SAVE: "scm-z.s.sr.ad.save-2",
    //销售退货（编辑）
    SR_ED: "scm-z.s.sr.ed-2",
    //销售退货（编辑-打印）
    SR_ED_PRINT: "scm-z.s.sr.ed.print-2",
    //销售退货（编辑-作废）
    SR_ED_CANCEL: "scm-z.s.sr.ed.cancel-2",
    //销售退货（编辑-保存）
    SR_ED_SAVE: "scm-z.s.sr.ed.save-2",
    //销售退货（编辑-库房确认）
    SR_ED_CONFIRM: "scm-z.s.sr.ed.confirm-2",
    //销售退货（编辑-结算）
    SR_ED_BILL: "scm-z.s.sr.ed.bill-2",
    //销售退货（编辑-新增商品）
    SR_ED_ADD_M: "scm-z.s.sr.ed.add-m-2",
    //销售退货（编辑-删除商品）
    SR_ED_DEL_M: "scm-z.s.sr.ed.del-m-2",
    //销售退货（编辑-下载模板）
    SR_ED_DLOAD: "scm-z.s.sr.ed.dload-2",
    //销售退货（编辑-导入商品）
    SR_ED_IM: "scm-z.s.sr.ed.im-2",
    //销售退货（导出）
    SR_EXPORT: "scm-z.s.sr.ex-2",

    //库存统计 (转移货位)
    ST_INVENT_TRANS: "scm-z.st.invent.trans-2",
    //库存统计 (导出)
    ST_INVENT_EX: "scm-z.st.invent.ex-2",

    //库存盘点 (新增)
    ST_STTAKE_AD: "scm-z.st.sttake.ad-2",
    //库存盘点 (保存)
    ST_STTAKE_AD_SAVE: "scm-z.st.sttake.ad.save-2",
    //库存盘点 (编辑)
    ST_STTAKE_ED: "scm-z.st.sttake.ed-2",
    //库存盘点 (编辑-作废)
    ST_STTAKE_ED_CANCEL: "scm-z.st.sttake.ed.cancel-2",
    //库存盘点 (编辑-盘点完成)
    ST_STTAKE_ED_FINISH: "scm-z.st.sttake.ed.finish-2",
    //库存盘点 (编辑-保存)
    ST_STTAKE_ED_SAVE: "scm-z.st.sttake.ed.save-2",
    //库存盘点 (编辑-新增商品)
    ST_STTAKE_ED_ADD_M: "scm-z.st.sttake.ed.add-m-2",
    //库存盘点 (编辑-删除商品)
    ST_STTAKE_ED_DEL_M: "scm-z.st.sttake.ed.del-m-2",
    //库存盘点 (编辑-导出盘库商品)
    ST_STTAKE_ED_DLOAD: "scm-z.st.sttake.ed.dload-2",
    //库存盘点 (编辑-导入商品)
    ST_STTAKE_ED_IM: "scm-z.st.sttake.ed.im-2",
    //库存盘点  (导出)
    ST_STTAKE_EX: "scm-z.st.sttake.ex-2",

    //商品管理 (新增)
    DATA_M_AD: "scm-z.data.m.ad-2",
    //商品管理 (新增-保存)
    DATA_M_AD_SAVE: "scm-z.data.m.ad.save-2",
    //商品管理 (编辑)
    DATA_M_ED: "scm-z.data.m.ed-2",
    //商品管理 (编辑 - 保存)
    DATA_M_ED_SAVE: "scm-z.data.m.ed.save-2",
    //商品管理 (导入)
    DATA_M_IM: "scm-z.data.m.im-2",
    //商品管理 (导出)
    DATA_M_EX: "scm-z.data.m.ex-2",
    //商品管理 (下载模板)
    DATA_M_DLOAD: "scm-z.data.m.dload-2",

    //客户管理 (新增)
    DATA_C_AD: "scm-z.data.c.ad-2",
    //客户管理 (新增-保存)
    DATA_C_AD_SAVE: "scm-z.data.c.ad.save-2",
    //客户管理 (编辑)
    DATA_C_ED: "scm-z.data.c.ed-2",
    //客户管理 (编辑 - 保存)
    DATA_C_ED_SAVE: "scm-z.data.c.ed.save-2",
    //客户管理 (导入)
    DATA_C_IM: "scm-z.data.c.im-2",
    //客户管理 (导出)
    DATA_C_EX: "scm-z.data.c.ex-2",
    //客户管理 (下载模板)
    DATA_C_DLOAD: "scm-z.data.c.dload-2",


    //供应商 门店共享
    DATA_S_SHARE: "scm-z.data.s.share-2",
    //供应商管理 (新增)
    DATA_S_AD: "scm-z.data.s.ad-2",
    //供应商管理 (新增-保存)
    DATA_S_AD_SAVE: "scm-z.data.s.ad.save-2",
    //供应商管理 (编辑)
    DATA_S_ED: "scm-z.data.s.ed-2",
    //供应商管理 (编辑 - 保存)
    DATA_S_ED_SAVE: "scm-z.data.s.ed.save-2",
    //供应商管理 (导入)
    DATA_S_IM: "scm-z.data.s.im-2",
    //供应商管理 (导出)
    DATA_S_EX: "scm-z.data.s.ex-2",
    //供应商管理 (下载模板)
    DATA_S_DLOAD: "scm-z.data.s.dload-2",

    //仓库管理 (新增)
    DATA_W_AD: "scm-z.data.w.ad-2",
    //仓库管理 (新增-保存)
    DATA_W_AD_SAVE: "scm-z.data.w.ad.save-2",
    //仓库管理 (编辑)
    DATA_W_ED: "scm-z.data.w.ed-2",
    //仓库管理 (编辑 - 保存)
    DATA_W_ED_SAVE: "scm-z.data.w.ed.save-2",

    //仓库管理 (编辑 - 区域信息 tab)
    DATA_W_ED_AREA: "scm-z.data.w.ed.area-2",
    //仓库管理 (编辑 - 区域信息 tab -新增)
    DATA_W_ED_AREA_AD: "scm-z.data.w.ed.area.ad-2",
    //仓库管理 (编辑 - 区域信息 tab -编辑)
    DATA_W_ED_AREA_ED: "scm-z.data.w.ed.area.ed-2",

    //仓库管理 (编辑 - 货架信息 tab)
    DATA_W_ED_SHELVES: "scm-z.data.w.ed.shelves-2",
    //仓库管理 (编辑 - 货架信息 tab -新增)
    DATA_W_ED_SHELVES_AD: "scm-z.data.w.ed.shelves.ad-2",
    //仓库管理 (编辑 - 货架信息 tab -编辑)
    DATA_W_ED_SHELVES_ED: "scm-z.data.w.ed.shelves.ed-2",

    //仓库管理 (编辑 - 货位信息 tab)
    DATA_W_ED_SHELF: "scm-z.data.w.ed.shelf-2",
    //仓库管理 (编辑 - 货位信息 tab -新增)
    DATA_W_ED_SHELF_AD: "scm-z.data.w.ed.shelf.ad-2",
    //仓库管理 (编辑 - 货位信息 tab -编辑)
    DATA_W_ED_SHELF_ED: "scm-z.data.w.ed.shelf.ed-2",

    //数据字典 (增加根级)
    DATA_DIC_FATHER: "scm-z.data.dic.father-2",
    //数据字典 (增加同级)
    DATA_DIC_BRO: "scm-z.data.dic.bro-2",
    //数据字典 (增加下级)
    DATA_DIC_SUB: "scm-z.data.dic.sub-2",


    //客户账单管理(账单详情)
    ACC_C_VW: "scm-z.ac.c.vw-2",
    //客户账单管理(调额)
    ACC_C_ADI: "scm-z.ac.c.vw.ac.adj-2",
    //客户账单管理(充值)
    ACC_C_CHARG: "scm-z.ac.c.vw.ac.charg-2",
    //客户账单管理(转账)
    ACC_C_TRANS: "scm-z.ac.c.vw.ac.trans-2",

    //供应商账单管理(账单详情)
    ACC_S_VW: "scm-z.ac.s.vw-2",
    //供应商账单管理(调额)
    ACC_S_ADI: "scm-z.ac.s.vw.ac.adj-2",
    //供应商账单管理(充值)
    ACC_S_CHARG: "scm-z.ac.s.vw.ac.charg-2",
    //供应商账单管理(转账)
    ACC_S_TRANS: "scm-z.ac.s.vw.ac.trans-2",

    //统计分析 配件交易频次（导出）
    STTICS_TRADE_EX: "scm-z.sttics.trade.ex-2",
    //统计分析 进销存明细（导出）
    STTICS_SPS_EX: "scm-z.sttics.sps.ex-2",
    //统计分析 客户销售情况（导出）
    STTICS_S_EX: "scm-z.sttics.s.ex-2",
    //统计分析 供应商采购情况（导出）
    STTICS_P_EX: "scm-z.sttics.p.ex-2",
    //统计分析 配件或客户销售情况（导出）
    STTICS_MC_EX: "scm-z.sttics.mc-s.ex-2",

}